import React from "react";
import { useTranslation } from "react-i18next";
import "./course.sponsors.cmp.scss";

export default function CourseSponsors() {
  const { t } = useTranslation();

  return (
    <section className="course-sponsors" aria-label={t("course.sponsors.title")}>
      <h2>{t("course.sponsors.title")}</h2>
      <p>{t("course.sponsors.description")}</p>
      <ul className="course-sponsors__list">
        {[1, 2, 3].map((number) => (
          <li key={number}>
            <span className="course-sponsors__logo" aria-hidden="true">
              {t("course.sponsors.logoPlaceholder")}
            </span>
            <strong>{t("course.sponsors.name", { number })}</strong>
            <span>{t("course.sponsors.placeholder")}</span>
          </li>
        ))}
      </ul>
      <a href="https://coachsafely.org/sponsors" target="_blank" rel="noopener noreferrer">
        {t("course.sponsors.viewAll")}
      </a>
    </section>
  );
}
